import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: '100%'
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
      color: 'black'
    },
  }));
  
  export default function HeaderBar(props) {
    const classes = useStyles();
  
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar style={{backgroundColor: 'white'}}>
            <IconButton edge="start" className={classes.menuButton} aria-label="menu" onClick={props.openSidebar ? props.closeNav : props.openNav}>
              <MenuIcon />
            </IconButton>
            <img src="https://s3.amazonaws.com/elucd-platform/elucd-logo-blue.svg" width={120} alt="Elucd logo" style={{marginTop: 10, marginBottom: 10}} />
            <p style={{marginLeft: 10, fontFamily: 'Roboto', color: '#09385d', fontSize: 30, fontWeight: 900, marginTop: 10, marginBottom: 10}}> survey manager </p>
          </Toolbar>
        </AppBar>
      </div>
    );
  }